import React from 'react';
import '../../../assets/css/components/admin/card/StatCard.css';

const StatCard = ({ icon: Icon, iconBg, iconColor, label, value, badge }) => (
  <div className="ksa-stat-card">
    <div className="ksa-stat-top">
      <p className="ksa-stat-label">{label}</p>
      <h2 className="ksa-stat-value">{value}</h2>
    </div>
    <div className="ksa-stat-icon" style={{ background: iconBg, color: iconColor }}>
      <Icon size={24} />
    </div>
  </div>
);

export default StatCard;
